<script setup>
import { useForm } from "@/form";
import { PrimaryButton } from "@Components/Button";
import { useI18n } from "vue-i18n";
import { MagicIcon } from "@Icons/index";
import { useRouter } from "vue-router";
import { getCurrentInstance, ref } from "vue";
import LanguageMenu from "@Components/LanguageMenu.vue";
import Preview from "./Partials/Preview.vue";
import SettingsPart from "./Partials/FormParts/SettingsPart.vue";
import Layout from "./Partials/Layout.vue";
import TitlePart from "./Partials/FormParts/TitlePart.vue";
import { useStore } from "@/Stores/singleModeGenerations";

const { t: __ } = useI18n();
const router = useRouter();
const store = useStore();

const [personas] = await Promise.all([
    new Promise((resolve, reject) => {
        useForm()
            .post("personas_index")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_users")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_templates")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_statuses")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_categories")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_post_types")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
]);

const form = useForm({
    type: "post",
    title: "",
    language: getCurrentInstance().appContext.config.globalProperties.$app.default_locale,
    persona_id: null,
    settings: {
        models: {
            text: "gpt-4.1-mini",
            image: "gpt_image_1_medium",
        },
        writing_style: null,
        sources: {
            enabled: false,
            no_follow: false,
            blank: false,
        },
        generation_brief: "",
        data: {
            serp: {
                enabled: true,
            },
            links: [],
        },
        custom_instructions: {
            profile: null,
            images: null,
        },
        text_length: "medium",
        images: {
            thumbnail: {
                enabled: true,
            },
            content: {
                enabled: true,
                max_images: 3,
            },
        },
        youtube: {
            enabled: true,
        },
        embeds: {
            enabled: true,
        },
        internal_links: {
            enabled: true,
        },
        external_links: {
            enabled: true,
        },
        custom_links: {
            enabled: false,
            links: [],
        },
        lists: {
            enabled: true,
        },
        tables: {
            enabled: true,
        },
        toolbox: {
            enabled: false,
        },
        bold_words: {
            enabled: true,
        },
        emojis: {
            enabled: false,
        },
        summary: {
            enabled: true,
        },
        faq: {
            enabled: true,
        },
        keywords: {
            custom: [],
        },
        seo_title: "",
        seo_description: "",
    },
    meta: {
        real_title: null,
        url: null,
        keywords: null,
        videoId: null,
    },
});

const focusedElement = ref();

const submitForm = async () => {
    const response = await form.post("single_mode_store");

    store.refresh();

    router.push({ name: "single-mode.show", params: { id: response.id } });
};

const focusElement = (element) => {
    focusedElement.value = element;
};

const blurElement = (element) => {
    if (focusedElement.value === element) {
        focusedElement.value = null;
    }
};
</script>

<template>
    <Layout>
        <div class="grid flex-1 grid-cols-12 lg:overflow-hidden">
            <div class="col-span-full px-4 py-8 lg:overflow-y-auto lg:col-span-6 lg:pr-4 lg:pl-8 sm:px-6">
                <form @submit.prevent="submitForm" class="space-y-6">
                    <LanguageMenu v-model="form.language" />

                    <TitlePart v-model="form" />

                    <SettingsPart v-model="form" :profiles="personas" />

                    <div class="flex justify-center">
                        <PrimaryButton type="submit" :processing="form.processing" :icon="MagicIcon">
                            {{ __("Générer") }}
                        </PrimaryButton>
                    </div>
                </form>
            </div>
            <div class="hidden col-span-full px-4 py-8 lg:overflow-y-auto lg:block lg:col-span-6 lg:pr-8 lg:pl-4 sm:px-6">
                <Preview :form="form" :focused-element="focusedElement" />
            </div>
        </div>
    </Layout>
</template>
